export const TOURNAMENT_NOT_FOUND_ERROR_MESSAGE =
  '404: The requested tournament was not found.';
